module.exports = __webpack_public_path__ + "img/img_paperMaterial2_test.c1dcc100.png";